export const HERA_MESSENGER_NEW_MESSAGE = 'HERA_MESSENGER_NEW_MESSAGE'
export const DAILY_ROSTER_IMPORT_COMPLETE = 'DAILY_ROSTER_IMPORT_COMPLETE'
export const DAILY_PERFORMANCE_DATA_IMPORT_COMPLETE = 'DAILY_PERFORMANCE_DATA_IMPORT_COMPLETE'
export const WEEKLY_PERFORMANCE_DATA_IMPORT_COMPLETE = 'WEEKLY_PERFORMANCE_DATA_IMPORT_COMPLETE'
export const TASK_REMINDER = 'TASK_REMINDER'
export const NEW_TASK = 'NEW_TASK'
export const COUNSELING_ACKNOWLEDGMENT = 'COUNSELING_ACKNOWLEDGMENT'
export const DOCUMENT_SIGNATURE_ACKNOWLEDGMENT = 'DOCUMENT_SIGNATURE_ACKNOWLEDGMENT'
export const VEHICLE_MAINTENANCE_REMINDER = 'VEHICLE_MAINTENANCE_REMINDER'
export const COUNSELING_SIGNED_BY_ASSOCIATE = 'COUNSELING_SIGNED_BY_ASSOCIATE'
export const HIDDEN = 'HIDDEN'
export const EXPORT_READY_FOR_DOWNLOAD = 'EXPORT_READY_FOR_DOWNLOAD'
export const ASSOCIATE_MATCHING_SCREEN_LANDING = 'ASSOCIATE_MATCHING_SCREEN_LANDING'
export const PAYROLL_PROVIDER_MATCHES_FOUND = 'PAYROLL_PROVIDER_MATCHES_FOUND'
export const SCHEDULING_SHIFTS_REVIEW = 'SCHEDULING_SHIFTS_REVIEW'
export const SCHEDULING_SHIFTS_IMPORT_COMPLETE = 'SCHEDULING_SHIFTS_IMPORT_COMPLETE'
export const ASSOCIATE_REQUEST_CREATED = 'ASSOCIATE_REQUEST_CREATED'